export default {
  LOGO: "navbar__logo",
  MESSAGES: "navbar__messages",
  CONSULTATIONS: "navbar__consultations",
  PATIENTS: "navbar__patients",
  PROFILE: "navbar__user-profile"
};
